// extracted by mini-css-extract-plugin
export default {"iconWrapper":"ThreadMediaSkeleton_iconWrapper__cSRRW","root":"ThreadMediaSkeleton_root__R+rFj"};